export function isMobileDevice() {
    if (typeof window === "undefined") return false;

    const values = [
        window.innerWidth,
        window.visualViewport?.width,
        document.documentElement?.clientWidth,
        window.screen?.width,
        window.screen?.availWidth
    ]
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value) && value > 0);

    const smallestWidth = values.length > 0 ? Math.min(...values) : 1024;

    return smallestWidth <= 768;
}